<template>
<section class="min-h-screen flex items-stretch text-white bg-[#F7F7F7]">

    <!-- Main Content -->
    <div class="flex-1 flex flex-col items-center py-6 md:px-16 px-4 z-0">
      <!-- Instructions Card -->
      <div id="instructions-card" class="text-black p-6 mb-6 w-full lg:w-3/4">
        <div class="flex items-center justify-center mb-4">
          <a href="#" class="flex items-center">
            <img src="../assets/images/logo.png" class="h-24" alt="Logo" />
          </a>
        </div>
        <h2 class="text-2xl mb-4 text-center text-[#090446]">You have successfully opt-out from receiving login reminders. To enable it again please contact our support team. Thanks </h2>
        
      </div>
    </div>
  </section>
</template>

<script>
import Api from '../router/api'
import HeaderEmployee from '../components/employee/includes/Header'
import FooterEmployee from '../components/employee/includes/Footer'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
/* eslint-disable */
export default {
  name: 'Unsubscribe',
  data() {
    return {
        email: ''
    }
  },
  
  components: { HeaderEmployee, FooterEmployee,  VueSlickCarousel },
  methods: {
    emailUnsubscribe: function () {
      let that = this
      Api.emailUnsubscribe(that.email)
    },
  },
  mounted() {
    let email = this.$route.fullPath.split('/')[3]
    this.email = email
    this.emailUnsubscribe()
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-group {
  margin-bottom: 1rem;
}

.err {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Unsubscribe.vue